var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMottekite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100",
      fill: "currentColor",
      width: "1.5em",
      height: "1.5em"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.hideArrow1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,65.3c0.4,0.7,1.2,1.2,2,1.2h6.2v6.1v13.7v10.8c0,1.3,1,2.3,2.3,2.3h61.9c5.4,0,9.7-4.4,9.7-9.7V66.5h7.1 c0.8,0,1.6-0.5,2-1.2c0.4-0.7,0.4-1.6-0.1-2.3l-8.6-13.7c-0.4-0.7-1.2-1.1-2-1.1H64.5c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0H15.5 c-0.8,0-1.5,0.4-2,1.1L5,63C4.6,63.7,4.5,64.6,5,65.3z M17.8,75h14.6v9.1H17.8V75z M17.8,88.7h16.9c1.3,0,2.3-1,2.3-2.3V72.7 c0-1.3-1-2.3-2.3-2.3H17.8v-3.8h37.8c0.8,0,1.5-0.4,2-1.1l4.3-6.9v36.3h-44V88.7z M82.5,89.8c0,2.8-2.3,5.1-5.1,5.1H66.5V58.1 l4.6,7.3c0.4,0.7,1.2,1.1,2,1.1h9.5C82.5,66.5,82.5,89.8,82.5,89.8z M84.4,52.9l5.7,9.1H74.3l-5.7-9.1H84.4z M16.8,52.9H60 l-5.7,9.1H11.2L16.8,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,37.8c0.4,0.4,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7l16-16c0.7-0.7,0.9-1.7,0.5-2.5c-0.4-0.9-1.2-1.4-2.1-1.4h-6.9V3 c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3v17.2c0,1.3,1,2.3,2.3,2.3H79L68.6,32.9L58.2,22.5h3.6c1.3,0,2.3-1,2.3-2.3V5.3h1.8 c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3h-4.1c-1.3,0-2.3,1-2.3,2.3v14.9h-6.9c-0.9,0-1.8,0.6-2.1,1.4c-0.4,0.9-0.2,1.9,0.5,2.5 L67,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hideArrow1",
    d: "M32.6,19v17.2c0,1.3,1,2.3,2.3,2.3s2.3-1,2.3-2.3V21.3h6.9c0.9,0,1.8-0.6,2.1-1.4c0.4-0.9,0.2-1.9-0.5-2.5 l-16-16c-0.9-0.9-2.4-0.9-3.3,0l-16,16C9.8,18,9.6,19,10,19.9c0.4,0.9,1.2,1.4,2.1,1.4H19v14.9c0,1.3,1,2.3,2.3,2.3h4.6 c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3h-2.3V19c0-1.3-1-2.3-2.3-2.3h-3.6L28.1,6.3l10.4,10.4h-3.6C33.7,16.7,32.6,17.7,32.6,19 z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMottekite);
export default __webpack_public_path__ + "static/media/icon-mottekite.b66da423.svg";
export { ForwardRef as ReactComponent };